import axios from 'axios';

const apiconfig = require('../config');

export function getPrimaryRating(ids, locale) {
  return new Promise((resolve, reject) => {
    const productId = encodeURI(ids.filter(Boolean).toString());

    axios
      .get(
        apiconfig.bazaarvoice[locale].api +
          '/products.json?apiversion=' +
          apiconfig.bazaarvoice[locale].apiversion +
          '&passkey=' +
          process.env.BAZAARVOICE_PASSKEY_DESKTOP +
          '&Filter=Id:' +
          productId +
          '&Stats=Reviews'
      )
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function getReviews(product, limit, offset, sortFilterValue, locale) {
  
  return new Promise((resolve, reject) => {
    axios
      .get(
        apiconfig.bazaarvoice[locale].api +
          '/reviews.json?apiversion=' +
          apiconfig.bazaarvoice[locale].apiversion +
          '&passkey=' +
          process.env.BAZAARVOICE_PASSKEY_DESKTOP +
          '&Filter=ProductId:' +
          encodeURI(product) +
          '&Stats=Reviews&limit=' +
          limit +
          '&offset=' +
          offset +
          sortFilterValue
      )
      .then(response => {
        resolve(response);
        
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function getFilterReviews(
  product,
  limit,
  offset,
  sortFilterValue,
  locale
) {
  return new Promise((resolve, reject) => {
    axios
      .get(
        apiconfig.bazaarvoice[locale].api +
          '/reviews.json?apiversion=' +
          apiconfig.bazaarvoice[locale].apiversion +
          '&passkey=' +
          process.env.BAZAARVOICE_PASSKEY_DESKTOP +
          '&Filter=ProductId:' +
          product +
          '&Stats=Reviews&limit=' +
          limit +
          '&offset=' +
          offset +
          sortFilterValue
      )
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function getPreview(write_post_data, locale) {
  return new Promise((resolve, reject) => {
    let url = `${apiconfig.bazaarvoice[locale].api}/submitreview.json?apiversion=${apiconfig.bazaarvoice[locale].apiversion}&passKey=${process.env.BAZAARVOICE_PASSKEY_DESKTOP}&ProductId=${write_post_data.rating}
    &Action=preview
    &rating=${write_post_data.rating}
    &reviewtext=${write_post_data.reviewText}
    &title=${write_post_data.reviewSummary}
    &contextdatavalue_Agemonth=${write_post_data.contextdatavalue_Agemonth}
    &contextdatavalue_Ageyear=${write_post_data.contextdatavalue_Ageyear}
    &usernickname=${write_post_data.userNickname}
    &userlocation=${write_post_data.userLocation}
    &useremail=${write_post_data.userEmail}
    &agreedtotermsandconditions=${write_post_data.agreedToTermsAndConditions}
    &isrecommended=${write_post_data.isRecommended}
    &hostedauthentication_authenticationemail=${write_post_data.hostedAuthentication_AuthenticationEmail}
    &hostedauthentication_callbackurl=${write_post_data.callBackURL}
    &fp=${write_post_data.fp}`;

    axios
      .post(url)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function submitReviews(write_post_data, locale, productID) {
  return new Promise((resolve, reject) => {
    let url = `${apiconfig.bazaarvoice[locale].api}/submitreview.json?apiversion=${apiconfig.bazaarvoice[locale].apiversion}&passKey=${process.env.BAZAARVOICE_PASSKEY_DESKTOP}&ProductId=${productID}
    &Action=Submit
    &rating=${write_post_data.rating}
    &reviewtext=${write_post_data.reviewText}
    &title=${write_post_data.reviewSummary}
    &contextdatavalue_Agemonth=${write_post_data.contextdatavalue_Agemonth}
    &contextdatavalue_Ageyear=${write_post_data.contextdatavalue_Ageyear}
    &usernickname=${write_post_data.userNickname}
    &useremail=${write_post_data.userEmail}
    &agreedtotermsandconditions=${write_post_data.agreedToTermsAndConditions}
    &isrecommended=${write_post_data.isRecommended}
    &hostedauthentication_authenticationemail=${write_post_data.hostedAuthentication_AuthenticationEmail}
    &hostedauthentication_callbackurl=${write_post_data.callBackURL};
    &fp=${write_post_data.fp}`;

    axios
      .post(url)
      .then(response => {
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}

export function submitFeedback(writeFeedbackData) {
  return new Promise((resolve, reject) => {
    const url = `${apiconfig.bazaarvoice[writeFeedbackData.localeVal].api}/submitfeedback.json?apiversion=${apiconfig.bazaarvoice[writeFeedbackData.localeVal].apiversion}&passKey=${process.env.BAZAARVOICE_PASSKEY_DESKTOP}&ContentId=${writeFeedbackData.ContentId}&ContentType=${writeFeedbackData.ContentType}&FeedbackType=${writeFeedbackData.FeedbackType}&Vote=${writeFeedbackData.Vote}
   `;
    axios
      .post(url)
      .then(response => {
        resolve(response);
      })

      .catch(function(error) {
        reject(error);
      });
  });
}
